import React from 'react';
import visa from 'Images/credit-cards/visa.svg';
import mastercard from 'Images/credit-cards/mastercard.svg';
import sepa from 'Images/logo_sepa.svg';

const Mark = ({ src, alt }) => (
  <span className="inline-flex items-center justify-center h-7 w-12 rounded bg-white border border-gray-200 px-1">
    <img src={src} alt={alt} className="max-h-5 max-w-full" />
  </span>
);

const TextMark = ({ children, className = '' }) => (
  <span
    className={`inline-flex items-center justify-center h-7 px-2 rounded border text-xs font-bold tracking-wide ${className}`}
  >
    {children}
  </span>
);


const MARKS = {
  'FINANCING/EASY_CREDIT': () => (
    <TextMark className="bg-white border-gray-200 text-[#1a5fb4]">easyCredit</TextMark>
  ),
  'CARD/STRIPE': () => (
    <>
      <Mark src={visa} alt="Visa" />
      <Mark src={mastercard} alt="Mastercard" />
    </>
  ),
  'SEPA/STRIPE': () => <Mark src={sepa} alt="SEPA" />,
  'INVOICE/MANUAL': () => <TextMark className="bg-gray-50 border-gray-300 text-gray-700">Rechnung</TextMark>,
};

export default function MethodMarks({ methodKey }) {
  const Marks = MARKS[methodKey];
  if (!Marks) return null;
  return (
    <span className="flex items-center gap-1.5 shrink-0" data-testid={`marks-${methodKey}`}>
      <Marks />
    </span>
  );
}
